import React, { useState } from 'react';
import { BsQuestionCircle, BsChevronDown, BsChevronUp } from 'react-icons/bs';

interface ModalHelpProps {
  text: string;
}

const ModalHelp: React.FC<ModalHelpProps> = ({ text }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ marginBottom: open ? '0' : '12px' }}>
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          cursor: 'pointer',
          fontSize: '13px',
          color: '#6c757d',
          userSelect: 'none',
          marginBottom: open ? '8px' : '0',
        }}
      >
        <BsQuestionCircle />
        <span>Ajuda</span>
        {open ? <BsChevronUp size={12} /> : <BsChevronDown size={12} />}
      </div>
      {open && (
        <div style={{
          backgroundColor: '#e8f4fd',
          border: '1px solid #bee5eb',
          borderRadius: '8px',
          padding: '10px 14px',
          marginBottom: '12px',
          fontSize: '13px',
          color: '#0c5460',
          lineHeight: '1.5',
        }}>
          {text}
        </div>
      )}
    </div>
  );
};

export default ModalHelp;
